<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Supplier Statement"
            />
            <div class="row match-height">
              <div class="col-12 col-lg-12 col-xl-12 col-xxl-12 mt-2">
                <DateQuerySetter
                    @onClickGo="getSupplierStatementData"
                >
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Account Head:</label>
                    <v-select
                        v-model="headId"
                        :options="accountHeads"
                        label="name"
                        placeholder="Select head"
                    />
                  </div>

                  <div v-if="!route.query.contactId" class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Party</label>
                    <AsyncSelect
                        placeholder="Party Name, ID, Mobile No"
                        v-model="contactProfile"
                        :api-service="fetchContactProfiles"
                        :format-label="formatPatientLabel"
                        :additional-query="{type: 'supplier'}"
                    />
                  </div>

                  <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Days Per Aging Period</label>
                    <input type="text" v-model="daysPerAgingPeriod" class="form-control" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Number Of Periods</label>
                    <input type="text" v-model="numberOfPeriod" class="form-control" />
                  </div>
                </DateQuerySetter>
              </div>
            </div>
        </div>

      <div class="mt-2 px-2">
        <div class="d-flex justify-content-between" v-if="tableItems.length">
          <div>
            <table class="head_left">
              <tr>
                <td>Party Name :</td>
                <td>
                  <strong>
                  {{ contactProfileData.name }}
                    <span v-if="contactProfileData.serial_no">({{ contactProfileData.serial_no }})</span>
                  </strong></td>
              </tr>
              <tr>
                <td>Mobile :</td>
                <td><strong>{{ contactProfileData.phone }}</strong></td>
              </tr>
              <tr>
                <td>Address :</td>
                <td><strong>{{ contactProfileData.address }}</strong></td>
              </tr>
              <tr>
                <td>Report Period :</td>
                <td><strong>{{ ledgerHeadData.report_period }}</strong></td>
              </tr>
              <tr>
                <td>Account Head :</td>
                <td><strong>{{ ledgerHeadData.account_name }}</strong></td>
              </tr>
            </table>
          </div>

          <div>
            <table class="head">
              <tr>
                <td>Opening Balance :</td>
                <td><strong>{{ commaFormat(ledgerData.opening_balance) }}</strong></td>
              </tr>
              <tr>
                <td>Total Purchase :</td>
                <td><strong>{{ commaFormat(ledgerData.total_purchase) }}</strong></td>
              </tr>
              <tr>
                <td>Total Payment :</td>
                <td><strong>{{ commaFormat(ledgerData.total_payment) }}</strong></td>
              </tr>
              <tr>
                <td>Total Adjustment :</td>
                <td><strong>{{ commaFormat(ledgerData.total_adjustment) }}</strong></td>
              </tr>
              <tr>
                <td>Closing Balance :</td>
                <td><strong>{{ commaFormat(ledgerData.closing_balance) }}</strong></td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row" v-if="tableItems.length">
          <div class="col-md-4 col-lg-3 col-12 py-1">
            <div class="card min-height card-hover-rise card-overdue mb-0">
              <div class="d-flex justify-content-between">
                <div class="text-left card-head">
                  <h5 class="px-1 pt-1 font-bold">Overdue</h5>
                </div>
              </div>
              <hr style="margin:0">
              <div class="card-body d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                  <h4 class="mb-25 font-bold text-left">
                    {{ commaFormat(ledgerData.closing_balance) }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-12 py-1" v-for="(period ,index) in agingPeriods" :key="index">
            <div class="card min-height card-hover-rise card-background mb-0">
              <div class="d-flex justify-content-between">
                <div class="text-left card-head">
                  <h5 class="px-1 pt-1 font-bold">{{ period.name || '' }}</h5>
                </div>
              </div>
              <hr style="margin:0">
              <div class="card-body d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                  <h4 class="mb-25 font-bold text-left">
                    {{ commaFormat(agingData[period.label] || 0) }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" v-if="tableItems.length">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="goToPrint"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
            >
              Print
            </button>
            <button
                @click="exportReport"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Export
            </button>
          </div>
        </div>
          <div class="table-responsive table-striped my-1" style="min-height: 200px">
            <table class="table table-bordered">
              <thead class="table-light">
              <tr>
                <th>Date</th>
                <th>Transaction Type</th>
                <th>Transaction Number</th>
                <th>Voucher Number</th>
                <th class="text-right">Debit</th>
                <th class="text-right">Credit</th>
                <th class="text-right">Balance</th>
                <th class="text-right">Bill Amount</th>
                <th class="text-right">Paid Amount</th>
                <th class="text-right">Adjustment Amount</th>
                <th class="text-right">Due Amount</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item ,index) in tableItems" :key="index">
                <td>{{ item.formatted_date }} </td>
                <td>{{ item.txn_type }}</td>
                <td>{{ item.bill_number }}</td>
                <td>{{ item.voucher_no }}</td>
                <td class="text-right">{{ commaFormat(item.debit) }}</td>
                <td class="text-right">{{ commaFormat(item.credit) }}</td>
                <td class="text-right">{{ commaFormat(item.balance) }}</td>
                <td class="text-right">
                  <span v-if="item.txn_type == 'bill_journal'">{{ commaFormat(item.subtotal_amount) }}</span>
                </td>
                <td class="text-right">
                  <span v-if="item.txn_type == 'bill_journal'">{{ commaFormat(item.paid_amount) }}</span>
                </td>
                <td class="text-right">
                  <span v-if="item.txn_type == 'bill_journal'">{{ commaFormat(item.adjusted_amount) }}</span>
                </td>
                <td class="text-right">
                  <span v-if="item.txn_type == 'bill_journal'">{{ commaFormat(item.due_amount) }}</span>
                </td>
                <td class="text-capitalize">
                  <span v-if="item.txn_type == 'bill_journal'">{{ item.payment_status }}</span>
                </td>
              </tr>
              </tbody>
            </table>
            <p v-if="!tableItems.length" class="mt-5 text-center">No data</p>
          </div>
        </div>
      <div class="px-2">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
      <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import {computed, inject, onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import Loader from "@/components/atom/LoaderComponent.vue";
import useReport from '@/services/modules/dashboard/report.js'
import handleContact from "@/services/modules/contact";
import figureFormatter from '@/services/utils/figureFormatter'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleJournal from '@/services/modules/journal'
import pdfPrinter from '@/services/utils/pdf/supplierStatementPdf';
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleCompany from "@/services/modules/company";
import {useStore} from "vuex";
import Pagination from "@/components/atom/Pagination.vue";
const { fetchSupplierStatement } = useReport()
const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = pdfPrinter();
const {
  fetchAccountHeadsList,
} = handleJournal()

const route = useRoute()
const router = useRouter();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const offset = ref(30)
const loading = ref(false);
const tableItems = ref([])
const ledgerData = ref({
  opening_balance: '0.00',
  closing_balance: '0.00',
  total_purchase: '0.00',
  total_payment: '0.00',
  total_adjustment: '0.00',
})
const agingPeriods = ref([])
const agingData = ref({})
const accountHeads = ref([])
const headId = ref(null)
const daysPerAgingPeriod = ref(30)
const numberOfPeriod = ref(3)
const contactProfile = ref(null);
const contactProfileData = ref({});
const companyInfo = ref(null);
const ledgerHeadData = ref({
  party_name: '',
  report_period: '',
  account_name: '',
})

const {commaFormat} = figureFormatter()

const from = computed(()=> store.state.paginationData.from)

const getPartyName = () => {
  if (!contactProfile.value) return ''
  return contactProfile.value.name
}

const getHeadName = () => {
  if (!headId.value) return ''
  return headId.value.name
}

function getQuery () {
    let queryStr = '?company_id=' + route.params.companyId
    queryStr += '&offset=' + offset.value
    if (route.query.page) queryStr += "&page=" + route.query.page;
    if (route.query.start) queryStr += "&start_date=" + route.query.start;
    if (route.query.end) queryStr += "&end_date=" + route.query.end;
    if(headId.value) queryStr += '&account_head_id=' + headId.value.id;
    if(contactProfile.value) queryStr += '&contact_profile_id=' + contactProfile.value.id;
    if(daysPerAgingPeriod.value) queryStr += '&days_per_aging_period=' + daysPerAgingPeriod.value;
    if(numberOfPeriod.value) queryStr += '&number_of_period=' + numberOfPeriod.value;
    return queryStr+`&payable_date={
    "start": "${route.query.start}",
    "end": "${route.query.end}"
    }`
}

const setLedgerHeadData = () => {
  ledgerHeadData.value.party_name = getPartyName()
  ledgerHeadData.value.report_period = route.query.start + ' to ' + route.query.end;
  ledgerHeadData.value.account_name = getHeadName()
}

 const getAccountHeads = async () => {
  try {
    loading.value = true;
    let accountHeadQuery = '?company_id=' + route.params.companyId + '&status=active&account_slug=accounts_payable';
    let res = await fetchAccountHeadsList(accountHeadQuery);
    if (!res.status) {
      showError(res.message);
    }
    accountHeads.value = res.data;
    headId.value = res.data[0]
  } catch (err) {
    showError("Something is wrong. Check your connectivity!!");
  } finally {
    loading.value = false;
  }
}

const getSupplierStatementData = async () => {
  if (!contactProfile.value) {
    showError("Please select Party");
    return;
  }

  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  loading.value = true;
  try {
    const res = await fetchSupplierStatement(getQuery())
    if (!res.status) {
      tableItems.value = []
      return store.commit("resetPagination")
    }

    tableItems.value = res.data.ledgers.data;
    Object.assign(ledgerData.value, {
      opening_balance: res.data.opening_balance,
      closing_balance: res.data.closing_balance,
      total_purchase: res.data.total_purchase,
      total_payment: res.data.total_payment,
      total_adjustment: res.data.total_adjustment
    })
    agingPeriods.value = res.data.aging_periods;
    agingData.value = res.data.aging_data;
    contactProfileData.value = res.data.contact_profile;
    if (tableItems.value.length > 0) {
      setPagination(res.data.ledgers)
    }
    setLedgerHeadData()
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  } finally {
    loading.value = false;
  }
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getSupplierStatementData()
}

const setPagination = (data) => {
  setPaginationData({
    from: data.from,
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const getCompany = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  })
}

const goToPrint = async() => {
  if (!contactProfile.value) {
    showError("Please select Party");
    return;
  }

  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  let printData = {};

  let query = getQuery();
  query += "&is_all=true";

  await fetchSupplierStatement(query).then((res) => {
    if (res.status){
      printData = res.data;
      printData.party_name = getPartyName()
      printData.report_period = route.query.start + ' to ' + route.query.end;
      printData.account_name = getHeadName()
      exportToPDF(companyInfo.value, printData)
    }
  })
}

onMounted(() => {
  getAccountHeads()
  getCompany();
  if (route.query.contactId) {
    contactProfile.value = {
      id: route.query.contactId,
    }
  }
})

const exportReport = () => {
  if (!contactProfile.value) {
    showError("Please select Party");
    return;
  }

  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  let token = localStorage.getItem('token');
  let url = `${process.env.VUE_APP_BASE_URL}/api/dashboard/accounting/supplier-statement${getQuery()}&_token=${token}&is_export=1`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}
</script>

<style scoped>
.min-height {
  min-height: 120px;
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
.truncate h4{
  font-size: 30px;
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
.card-overdue{
  background-color: #ffeaea;
}
.card-background{
  background-color: rgba(0, 207, 232, 0.12);
}
</style>
